//antd
import Card from 'antd/lib/card'
import Col from 'antd/lib/col'
import Row from 'antd/lib/row'

const Services = () => {
  const services = [
    {
      title: 'Casillero en Miami',
      desc: 'Te damos dirección en USA para enviar tus compras online.',
    },
    {
      title: '🛒 Te hacemos tus compras!!!',
      desc: 'Nos encargamos por vos de todo el proceso. Solo decinos qué querés comprar.',
    },
    {
      title: 'Envío aéreo',
      desc: 'Rápido y seguro, ideal para paquetes pequeños o urgentes.',
    },
    {
      title: 'Envío maritimo',
      desc: 'Confiable y seguro, ideal para paquetes grandes.',
    },
    {
      title: 'Soporte personalizado en tus compras',
      desc: 'Te guiamos y asistimos durante todo el proceso de compra en tiendas en línea.',
    },
    {
      title: 'Entrega Rápida y segura',
      desc: 'Te entregamos tus paquetes seguros, de manera confiable y a tiempo en Nicaragua.',
    }
  ];

  return (
    <div className="py-5">
      <h2 className="text-center mb-4">Servicios que ofrecemos</h2>
      <Row gutter={[16, 16]}>
        {services.map((service, index) => (
          <Col key={index} xs={24} md={12}>
            <Card title={service.title} className="shadow">
              <p>{service.desc}</p>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Services;